import {
	AlignButtonLeft,
	AlignButtonCenter,
	AlignButtonRight,
} from './components/AlignButton';
import alignKeymap from './plugins/keymap';

const align = {

	plugins() {

		return [alignKeymap];

	},

	toolbarButtons() {

		return [
			{ Button: AlignButtonLeft, key: 'AlignButtonLeft' },
			{ Button: AlignButtonCenter, key: 'AlignButtonCenter' },
			{ Button: AlignButtonRight, key: 'AlignButtonRight' },
		];

	},

};

export default align;
